import { IgMedia } from '@core/models/ApiFields/ig-entities';
import { ApiResComparison, IgAccCard } from '@features/social-analysis/models/IComparison';
import { PageFiltersState } from '@features/social-analysis/social-shared/store/page-filters.store';
import { BaseState, DATA_STATUS } from '@features/social-analysis/social-shared/store/state.store';
import { finalize } from 'rxjs/operators';
import { HttpBuilder } from '../../social-shared/services/http/http-builder';
import { IG_ENDPOINT, fixdFields } from '../config/api-params';
import { AccCompareCard } from '../models/I-compare';

export class CompareHttpBuilder extends HttpBuilder<BaseState<AccCompareCard>> {
    reqData(state: BaseState<AccCompareCard>, pageFilters: PageFiltersState, igAcc: string) {
        state.isLoading.set(true);
        const url = this.buildUrl(IG_ENDPOINT);
        const params = this.#buildParams(pageFilters);

        this.http
            .get<ApiResComparison>(url, { params: params })
            .pipe(finalize(() => state.isLoading.set(false)))
            .subscribe({
                next: res => this.#handleCompetitorsSuccess(state, res.data, igAcc),
                error: err => this.handleError(err?.error?.message),
            });
    }

    #buildParams(pageFilters: PageFiltersState) {
        const fields = fixdFields.competitorAcc.join();
        return {
            ...this.getDates(pageFilters.selectedDates()),
            fields: fields,
            mode: 1,
            ...this.getMediaTypeFilter(),
            ...this.formatFilters(pageFilters.appliedFilters()),
        };
    }

    private getMediaTypeFilter() {
        return { [IgMedia.getPrefixed('mediaType')]: 'neq:tag' };
    }

    #handleCompetitorsSuccess(state: BaseState<AccCompareCard>, data: IgAccCard[], igAcc: string) {
        const newData: AccCompareCard[] = data.map(
            acc =>
                new AccCompareCard(
                    acc?.ig_account.ig_account,
                    acc?.ig_account.image,
                    acc?.ig_account.followers,
                    acc?.social_media.engagement_rate,
                    acc?.social_media.comments,
                    acc?.social_media.likes,
                    acc?.social_media.media_count
                )
        );
        const userAccIndex = newData.findIndex(acc => acc.igAccount === igAcc);

        if (userAccIndex !== -1) {
            const userAcc = newData.splice(userAccIndex, 1)[0];
            newData.unshift(userAcc);
        }

        state.data.set(newData);
        state.dataStatus.set(DATA_STATUS.OK);
    }
}
